import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app.component';
import { ConfigService} from './config/config.service';
import { HttpErrorHandler } from './http-error-handler.service';
import { MessageService } from './message.service';
import { RemoveSpacePipe } from './shared/remove-space.pipe';
import {LOCALE_ID} from '@angular/core';
import ptBr from '@angular/common/locales/pt';
import {registerLocaleData} from '@angular/common';
registerLocaleData(ptBr)

import { NgxSpinnerModule } from 'ngx-spinner';
import {RouterModule} from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { PesquisaComponent } from './pages/pesquisa/pesquisa.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
@NgModule({
  declarations: [
    AppComponent,
    RemoveSpacePipe,
    PesquisaComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgxSpinnerModule,
    RouterModule.forRoot([]),
    AppRoutingModule
  ],
  providers: [ ConfigService, HttpErrorHandler, MessageService, { provide: LOCALE_ID, useValue: 'pt' }],
  bootstrap: [AppComponent]
})
export class AppModule { }
